import { Button } from '@headlessui/react'
import classNames from 'classnames'
import React, { PropsWithChildren } from 'react'
import { useNavigate } from 'react-router-dom'
import {
  Plan,
  PlanDetailType,
  SubscriptionPlan,
  subscriptionType,
  SubscriptionType,
} from 'service/plans'
import { Me } from 'service/user'
import { FunctionBox } from './FunctionBox'
import { FeatureBox } from './FeatureBox'
import { createLogger } from 'utils/logger'
import { UserType } from 'utils/common'

const logger = createLogger('short-form-price')
interface ShortFormProps {
  userInfo: Me
  plan: Plan
  price: SubscriptionType | undefined
  type: string
  paybackCoupon: () => boolean
  getPaymentOrderRequests: (
    planId: number,
    planPriceId: number,
    planPrice: SubscriptionPlan | null
  ) => void
  handleBrandPay: (
    planId: number,
    planPriceId: number,
    planPrice: SubscriptionPlan | null
  ) => void
}

export const ShortForm = ({
  userInfo,
  plan,
  price,
  type,
  paybackCoupon,
  getPaymentOrderRequests,
  handleBrandPay,
}: PropsWithChildren<ShortFormProps>) => {
  const navigate = useNavigate()
  const getButtonLabel = ({ userInfo }: { userInfo: Me }): string => {
    //1.사용하기
    if (userInfo?.userType === UserType.USER || !userInfo?.userType) {
      return '사용하기'
    } else if (
      userInfo?.userType === UserType['숏폼 스페셜'] &&
      userInfo?.subscriptions?.subscriptionType === subscriptionType.MONTHLY
    ) {
      return '업그레이드'
    }
    return '문의하기'
  }
  return (
    <div
      className={classNames(
        'border rounded-[20px] border-[#EEF1F7] shadow-main flex flex-col md:w-[328px] w-[343px]  gap-[32px] px-[24px] py-[40px] '
      )}
      key="short_form_list"
    >
      <div className="flex flex-col items-center">
        <p className="font-bold text-href text-[24px] flex gap-[2px]">
          {plan?.name}
        </p>
        {price?.benefitType === 'invite' && (
          <p className="text-error font-bold">
            {' '}
            첫 결제 +{' '}
            {/* {`${price.prices[
              i
            ].planPrice[0].bonusPoint?.toLocaleString()}`}{' '} */}
            캐시 보너스
          </p>
        )}

        {!!price?.prices?.length &&
        price.prices[4].planPrice[0].subscriptionType === 'monthly' ? (
          <>
            {price?.benefitType === 'coupon' && (
              <>
                <p className="text-error font-bold text-[18px] h-[19px]">
                  {userInfo?.subscriptions?.planName === plan?.name &&
                    '미션 성공 20% 할인'}
                </p>
                <s className="font-bold text-[#8F929B] text-[24px] h-[29px]">
                  {userInfo?.subscriptions?.planName === plan?.name &&
                    `   ₩${price.prices[4]?.planPrice[0].originPrice.toLocaleString()}`}
                </s>{' '}
              </>
            )}
            <p>
              <span className="font-bold text-[32px]">
                ₩
                {!!price?.prices?.length &&
                  price.prices[4]?.planPrice[0].price.toLocaleString()}
              </span>{' '}
              <span className="font-bold "> /월(VAT 별도)</span>
            </p>
          </>
        ) : (
          <>
            {/* annual 가격 폼 */}
            <p className="flex flex-col items-center">
              {userInfo?.affiliate.plan?.length > 0 && (
                <>
                  <p className="text-error font-bold text-[18px]">
                    {userInfo?.affiliate?.plan[0]?.name}
                  </p>
                </>
              )}

              <p>
                {' '}
                <s className="font-bold text-[#8F929B] text-[24px]">
                  ₩
                  {!!price?.prices?.length &&
                    price.prices[4]?.planPrice[0].monthlyPrice.toLocaleString()}
                  {` `}
                </s>{' '}
                <s className="text-[16px] text-[#8F929B] font-bold">/월</s>
              </p>

              <p>
                <span className="font-bold text-[32px]">
                  ₩
                  {!!price?.prices?.length &&
                    Number(
                      price.prices[4]?.planPrice[0].descriptionPrice
                    ).toLocaleString()}
                </span>
                <span className="font-bold"> /월(VAT 별도)</span>
              </p>
            </p>
            <span className="text-[18px] text-[#8F929B]">
              ₩
              {!!price?.prices?.length &&
                Number(price.prices[4]?.planPrice[0].price).toLocaleString()}
              /1년
            </span>
          </>
        )}

        {type === 'annual' &&
          (userInfo?.userType === UserType.USER ||
            userInfo?.subscriptions?.subscriptionType ===
              subscriptionType.MONTHLY ||
            !userInfo?.userType) && <div className="mt-2 w-[119px] h-[48px]" />}
      </div>

      <div>
        <Button
          className="bg-href w-full h-[48px] border-none rounded-[48px] text-white font-bold disabled:opacity-[0.5]"
          onClick={() => {
            if (type === 'annual') {
              getPaymentOrderRequests(
                plan.id,
                !!price?.prices?.length ? price.prices[4]?.planPrice[0].id : 0,
                !!price?.prices?.length ? price.prices[4]?.planPrice[0] : null
              )
            } else {
              handleBrandPay(
                plan.id,
                !!price?.prices?.length ? price.prices[4]?.planPrice[0].id : 0,
                !!price?.prices?.length ? price.prices[4]?.planPrice[0] : null
              )
            }
          }}
        >
          {getButtonLabel({ userInfo })}
        </Button>
        {}
      </div>
      <div className="flex flex-col">
        <div className="plan flex flex-col md:h-[250px] h-auto ">
          <p className="font-bold text-[18px] flex items-center gap-[5px] mb-[24px]">
            <img
              src="assets/img/check_circle_blue.png"
              alt="check_circle"
              width={24}
              height={24}
            />
            {type === 'annual' ? <>12개월 사용</> : <>1개월 사용</>}
          </p>

          {plan?.planDetail.map((el: PlanDetailType, index) => {
            return <FeatureBox planDetail={el} index={index} planId={plan.id} />
          })}
        </div>
        <hr className="mt-[10px] mb-[30px] h-auto" />
        <div className="flex flex-col detail-function-list">
          {plan?.planDetail.map((el: PlanDetailType, index) => {
            return (
              <FunctionBox planDetail={el} index={index} planId={plan.id} />
            )
          })}
        </div>
      </div>
    </div>
  )
}
